import { useTenantSetting } from "@nestoca/multi-tenant";
import { OptionItem } from "@shared/ui";
import { useTranslation } from "react-i18next";

import { OWNED_PROPERTY_TYPE } from "./property-purpose.const";

const PROPERTY_TYPE_LABEL: Record<string, string> = {
  DETACHED: "owned-property:detached",
  SEMI_DETACHED: "owned-property:semiDetached",
  DUPLEX_DETACHED: "owned-property:duplexDetached",
  DUPLEX_SEMI_DETACHED: "owned-property:duplexSemiDetached",
  ROW_HOUSING: "owned-property:rowHousing",
  APARTMENT_LOW_RISE: "owned-property:apartmentLowRise",
  APARTMENT_HIGH_RISE: "owned-property:apartmentHighRise",
  MOBILE: "owned-property:mobile",
  TRI_PLEX_DETACHED: "owned-property:triPlexDetached",
  TRI_PLEX_SEMI_DETACHED: "owned-property:triPlexSemiDetached",
  STACKED: "owned-property:stacked",
  MODULAR_HOME_DETACHED: "owned-property:modularHomeDetached",
  MODULAR_HOME_SEMI_DETACHED: "owned-property:modularHomeSemiDetached",
  FOUR_PLEX_DETACHED: "owned-property:fourplexDetached",
  FOUR_PLEX_SEMI_DETACHED: "owned-property:fourplexSemiDetached",
  SeasonalHome: "owned-property:seasonalHome",
  OTHER: "owned-property:other",
  Condominium: "owned-property:condo"
};

export const useOwnedPropertyTypeOptions = (): OptionItem[] => {
  const { settings: { propertyTypes } = {} } =
    useTenantSetting("typesOverride");

  const { t } = useTranslation("owned-property");

  if (!propertyTypes) {
    return OWNED_PROPERTY_TYPE.map((option) => ({
      value: option.value,
      label: t(option.label),
    }));
  }

  return propertyTypes.map((type) => ({
    value: type,
    label: t(PROPERTY_TYPE_LABEL[type] ?? type),
  }));
};
